import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  color: var(--text-text01);
  font-size: 12px;
  line-height: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

interface OrganizedByProps {
  organizedBy: string;
}

const OrganizedBy = (props: OrganizedByProps) => {
  const { organizedBy } = props;

  return (
    <Container>
      Organizado por: <strong>{organizedBy}</strong>
    </Container>
  );
};

export default OrganizedBy;
